import { useEffect, useState } from 'react'
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  startAfter,
} from 'firebase/firestore'
import { db } from '../firebase.config'
import { toast } from 'react-toastify'
import Spinner from '../components/Spinner'
import ListingItem from '../components/ListingItem'
import { IoMdCheckmark } from "react-icons/io";
import { FaXmark } from "react-icons/fa6";
import { MdAlternateEmail } from "react-icons/md";
import { FiPhoneCall } from "react-icons/fi";

function Kontakti() {
  const [listings, setListings] = useState(null)
  const [loading, setLoading] = useState(true)
  const [lastFetchedListing, setLastFetchedListing] = useState(null)



  return (

    <div className='category'>

      <div className='falaspremiumContainer'>
        <div className='falas'>
          <h2>Falas</h2>
          <h3 className='cmimiPremium'>0€</h3>
          <p>Veçoritë</p>
          <p><IoMdCheckmark /> Shfaqet ne portal</p>
          <p><FaXmark /> Nuk shfaqet tek pjesa Premium</p>
          <p><IoMdCheckmark /> Kohezgjatja e pakufizuar</p>
          <p><FaXmark /> Perkrahje Teknike</p>
          <p><FaXmark /> Numer i limituar i shpalljeve</p>
        </div>

        <div className='premium'>
          <h2>Premium</h2>
          <h3 className='cmimiPremium'>50€</h3>
          <p>Veçoritë</p>
          <p><IoMdCheckmark />Shfaqet ne portal</p>
          <p><IoMdCheckmark /> Shfaqet tek pjesa Premium</p>
          <p><IoMdCheckmark /> Kohezgjatja e pakufizuar</p>
          <p><IoMdCheckmark /> Perkrahje Teknike</p>
          <p><IoMdCheckmark /> Numer i palimituar i shpalljeve</p>
        </div>
      </div>

      <div className='kontaktContainer'>
        <div className='phoneCont'>
          <p className='telefoni'>
          <FiPhoneCall /></p><p className='telefoniText'>+383 44 361 669</p>
        </div>
        <div className='phoneCont'>
          <p className='telefoni'>
          <MdAlternateEmail /></p><p className='telefoniText'>info@konkurse.co</p>
        </div>

      </div>
    </div>
  )
}

export default Kontakti
